var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-bar mdl-cell mdl-cell--6-col mdl-cell--3-offset-desktop mdl-cell--1-offset-tablet mdl-shadow--4dp",class:{'mdl-color--amber-600':_vm.isWarning, 'mdl-color--grey-600':_vm.isInfo, 'mdl-color--green-600':_vm.isSuccess}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }